import React from 'react';
import { IStyleSettingColors } from 'types';
import StyleSection from './StyleSection';
import classNames from 'classnames';
import style from './AdditionalColors.module.scss';

interface IAdditionalColors {
	setStyleSettings(styleItemId: string, value: string, key: string): void;
	navigationItems: string[];
	additionalColors: IStyleSettingColors['additionalColors'];
	selectedNavigationItem: string | null;
	useCustomerSettings: boolean;
}

const AdditionalColors: React.FC<IAdditionalColors> = ({
	setStyleSettings,
	navigationItems,
	additionalColors,
	selectedNavigationItem,
	useCustomerSettings,
}) => {
	return (
		<div className={style.container}>
			{additionalColors &&
				navigationItems.map((navigationItem) => {
					const styleSectionContainerClasses = classNames(style.styleSectionContainer, {
						[style.hideStyleSectionContainer]: navigationItem !== selectedNavigationItem,
					});

					return (
						<div className={styleSectionContainerClasses} key={navigationItem}>
							{Object.keys(additionalColors[navigationItem]).map((row) => (
								<StyleSection
									keyName={row}
									styleData={additionalColors[navigationItem]}
									setStyleSettings={setStyleSettings}
									useCustomerSettings={useCustomerSettings}
									key={row}
								/>
							))}
						</div>
					);
				})}
		</div>
	);
};

export default React.memo(AdditionalColors);
